// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1CTUa","title":"Header_title__2efTv","side":"Header_side__1KUFM"};